import { render, staticRenderFns } from "./DetailsNamePointers.vue?vue&type=template&id=4d4b3574"
import script from "./DetailsNamePointers.vue?vue&type=script&lang=js"
export * from "./DetailsNamePointers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports